// extracted by mini-css-extract-plugin
export default {"con":"Billing_con__xjKfZ","success":"Billing_success__RnnCJ","desc":"Billing_desc__3BIwd","warn":"Billing_warn__PDxDJ"};